// webpackでSassファイルをコンパイルするためにインポート
import '../sass/my-style.scss';

const MOBILE_BREAK_POINT = 960;

// -----------------------------------------------
// viewport切り替え（引数breakpointの幅未満はviewportを固定にする）
// -----------------------------------------------
function switchViewport(breakpoint) {
  // viewportのセレクタ取得
  const viewport = document.querySelector('meta[name="viewport"]');
  const value = window.outerWidth > breakpoint ? 'width=device-width,initial-scale=1,viewport-fit=cover' : 'width=' + breakpoint;
  if (viewport.getAttribute('content') !== value) {
    viewport.setAttribute('content', value);
  }
}

// -----------------------------------------------
// 指定されたidのページの場合True返却
// -----------------------------------------------
function isPage(id) {
  // ★bodyタグに付与されたidと比較判定する
  return document.querySelector('body').getAttribute('id') === id ? true : false;
}

// -----------------------------------------------
// モバイル端末なら true 、それ以外なら false を返す
// -----------------------------------------------
function isMobile() {
  return window.innerWidth <= MOBILE_BREAK_POINT;
}

// -----------------------------------------------
// PCなら true 、それ以外なら false を返す
// -----------------------------------------------
function isPc() {
  return !isMobile();
}

// -----------------------------------------------
// ブラウザの縦のサイズを取得し、セットする（iOS対策）
// -----------------------------------------------
function setHeightFromWindowHight(target) {
  target = document.querySelector(target);
  if (!target) return;

  const hSize = window.innerHeight;
  let paddingTop = 0;
  let paddingBottom = 0;
  const headerHeight = document.querySelector('#header').clientHeight;

  // if (Utils.isPc()) {
  //   paddingTop = Number(getComputedStyle(target).paddingTop.replace('px', ''));
  //   paddingBottom = Number(getComputedStyle(target).paddingBottom.replace('px', ''));
  // }
  target.style.height = hSize + paddingTop + paddingBottom - headerHeight + 'px';
}

// -----------------------------------------------
// ページ内リンクの場合Trueを返却する
// -----------------------------------------------
function isInPageLink(event) {
  // ブラウザのURL取得（プロトコル「https:」は削除）
  let pageUrl = location.origin + location.pathname;
  pageUrl = pageUrl.replace(location.protocol, '');

  // 最後の文字が「/」なら削除する
  if (pageUrl.slice(-1) === '/') {
    pageUrl = pageUrl.slice(0, -1);
  }

  // リンクのhref取得（プロトコル「https:」は削除）
  let linkHref = event.currentTarget.getAttribute('href');
  linkHref = linkHref.replace(location.protocol, '');

  // 差分取得
  let diff = linkHref.replace(pageUrl, '');

  // 先頭の文字が「/」なら削除する
  if (diff.slice(0, 1) === '/') {
    diff = diff.slice(1);
  }

  if (diff.indexOf('#') === 0 || diff === '') {
    return true;
  } else {
    return false;
  }
}

// -----------------------------------------------
// ポジション移動（スムーズスクロール）
// -----------------------------------------------
function movePosition(target) {
  // href属性値取得
  const href = target.getAttribute('href');
  if (href.indexOf('#') < 0) {
    // #がなければ抜ける
    // 親イベントを実行させるためtrue返却
    return true;
  }

  // href属性値からターゲットとなるセレクターを取得する
  let targetSelector = '';
  if (href === '#') {
    targetSelector = 'html';
  } else {
    // 末尾の「#○○○」だけを切り出す
    const id = href.split('#');
    targetSelector = '#' + id[id.length - 1];
  }

  if (!document.querySelector(targetSelector)) {
    // ターゲット要素が存在しない場合は何もしないで抜ける
    return false;
  }

  // 移動処理
  // .headerクラスがついた要素の高さを取得
  const header = document.querySelector('.js-header').clientHeight;
  // const header = 80;
  // const speed = 1000;

  // 位置を取得（ヘッダー分の高さを引く、その分だけ移動すればヘッダーと被らない）
  const position = document.querySelector(targetSelector).getBoundingClientRect().top + window.pageYOffset - header;
  window.scrollTo({ top: position, behavior: 'smooth' });
  return false;
}

// -----------------------------------------------
//iOS（iPadOSを含む）かどうかのUA判定
// -----------------------------------------------
function isiOS() {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document);
}

// -----------------------------------------------
// 文字列の場合はTrueを返却する
// -----------------------------------------------
function isString(value) {
  if (typeof value === 'string' || value instanceof String) {
    return true;
  } else {
    return false;
  }
}

// -----------------------------------------------
// スライダー初期化
// -----------------------------------------------
function initSwiper() {
  // FVスライダー
  if (document.querySelector('.js-fv-slider')) {
    const fvSwiper = new Swiper('.js-fv-slider', {
      slidesPerView: 1,
      // loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      // loopedSlides: 7,
      speed: 2400,
      allowTouchMove: true,

      // 自動再生
      autoplay: {
        delay: 1200,
        stopOnLastSlide: true,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination', //ページネーションの要素のセレクタ
        type: 'bullets', //ページネーションのタイプ
        clickable: true,
      },
    });

    // 自動再生の開始ディレイ
    fvSwiper.autoplay.stop();
    setTimeout(() => {
      fvSwiper.autoplay.start();
    }, 1600);
  }

  // 運営メンバースライダー
  if (document.querySelector('.js-member-slider')) {
    const memberSwiper = new Swiper('.js-member-slider', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 21,
      pagination: {
        el: '.top-member__pagination', //ページネーションの要素のセレクタ
        type: 'bullets', //ページネーションのタイプ
        clickable: true,
      },
      breakpoints: {
        // 960px以上の場合
        960: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
      },
    });
  }

  // ナビゲータースライダー
  if (document.querySelector('.js-navigator-slider')) {
    const navigatorSwiper = new Swiper('.js-navigator-slider', {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 21,
      pagination: {
        el: '.top-navigator__pagination', //ページネーションの要素のセレクタ
        type: 'bullets', //ページネーションのタイプ
        clickable: true,
      },
      breakpoints: {
        // 960px以上の場合
        960: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
      },
    });
  }
}

// -----------------------------------------------
// 水平方向に自動スクロール
// -----------------------------------------------
let scrollPositionX = 0;
// スクロール処理（非同期処理）
async function scrollX(target, delay = 5) {
  return new Promise(function (resolve, reject) {
    setTimeout((target) => {
      target.scrollLeft = ++scrollPositionX;
      if (scrollPositionX > target.scrollWidth - target.clientWidth) {
        // スクロールが端までいったらfalseを返却
        resolve(false);
        return;
      }
      resolve(true);
    }, delay, target);
  });
}
// 自動水平スクロール処理（非同期処理）
async function doAutoScrollingX() {

  let isAutoScroll = true;

  if (isMobile()) {
    if (document.querySelector('.js-auto-scroll')) {
      document.querySelector('.js-auto-scroll').addEventListener('touchstart', (event) => {
        // タップ時はスクロールを停止
        isAutoScroll = false;
      });
    }
  }

  const target = document.querySelector('.js-auto-scroll');
  while (isAutoScroll) {
    // // 自動スクロール中は、非同期でスクロール処理を繰り返す
    if (!(await scrollX(target, 10))) {
      break;
    }
  }
}

//-------------------------------------------
// DOMロードイベント
//-------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  //-------------------------------------------
  // イベント
  //-------------------------------------------
  // #から始まるURLクリック
  if (document.querySelector('a[href*="#"]')) {
    document.querySelectorAll('a[href*="#"]').forEach((el) => {
      el.addEventListener('click', (event) => {
        if (isInPageLink(event)) {
          // ページ内リンクの場合、親イベントを破棄し、スムーズスクロールで移動
          event.preventDefault();
          movePosition(event.currentTarget);
        }
      });
    });
  }

  // アコーディオンクリック
  if (document.querySelector('.js-accordion .js-accordion-button')) {
    document.querySelectorAll('.js-accordion .js-accordion-button').forEach((el) => {
      el.addEventListener('click', (event) => {
        event.preventDefault();
        event.target.classList.toggle('is-open');
        jQuery(event.target).next().slideToggle(500);
      });
    });
  }

  //-------------------------------------------
  // 表示関連処理
  //-------------------------------------------
  switchViewport(389);

  // FVアニメーション
  if (document.querySelector('.js-fv-anime')) {
    ScrollTrigger.create({ trigger: '.js-fv-anime', markers: false, onEnter: () => playFvAnime() });
  }

  // 自動スクロール
  if (isMobile()) {
    if (document.querySelector('.js-auto-scroll')) {
      doAutoScrollingX();
    }
  }

  initSwiper();

  if (isPc()) {
    setHeightFromWindowHight('.js-height-setting');
  }
});

//-------------------------------------------
// Windowロードイベント
//-------------------------------------------
// window.addEventListener('load', () => {});

